














































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
// Importing functions
import {deleteItem} from '@/ts/cart/delete-item';
import {putItem} from '@/ts/cart/put-item';

export default {
    name: 'TheCartItemList',
    components: {
        BaseButton,
    },
    props: {
        data: Object,
        quantity: Array,
    },
    data() {
        return {
            options: Array(),
        };
    },
    methods: {
        removeItem(id) {
            deleteItem(id, this.$route.query.restaurant).then((response: any) => {
                this.$emit('refresh', response);
                for (const item of response.data) {
                    this.$set(this.quantity, item.id, item.attributes.quantity);
                }
            });
        },
        refreshItem(event, id) {
            putItem(id, this.$route.query.restaurant, event).then((response: any) => {
                this.$emit('refresh', response);
                for (const item of response.data) {
                    this.$set(this.quantity, item.id, item.attributes.quantity);
                }
            });
        },
    },
    mounted() {
        this.options = [1, 2, 3, 4, 5];
    },
};
